module.exports = __webpack_public_path__ + "img/solution_icon3.3751f3fd.png";